import '../scss/vendor.scss';
import '../scss/fallacy.scss';
import '../images';

import './src/bootstrap';

require('./app/app');
require('./lib');
require('./modules');
require('./animations');
require('./app/run');



// WEBPACK FOOTER //
// ./resources/assets/js/fallacy.js